goog.provide('el8.appchart.dialog.mergeChart');

goog.require('el8.appservice.search');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.ptdata.plrCollaborators');
goog.require('el8.service.intervals');
goog.require('el8.service.pageunload');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.dialog.mergeChart');
goog.require('el8.template.mindreader');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.string');
goog.require('el8.util.amplitude.helpers');
goog.require('el8.ptdata.ptRegistrationInfo');
goog.require('el8.uiwidget.alert');

el8.appchart.dialog.mergeChart = (function() {

    var currPatientItem = null;
    var pollInterval = null;
    var pollAttempts = 0;
    var mergeJobId = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Patient Chart Merge',
        modal: true,
        width: 350,
        autoHeight: true,
        contentFn: function() {
            return el8.template.appchart.dialog.mergeChart.content();
        }
    });
    var mindreaderOpts = el8.appshared.mindreaderOpts.patient({
        selectFn: function(event, item) {
            $.el8_ajax({
                type: 'GET',
                async: false,
                url: "/patient/" + item.id + "/practice-details/",
                success: function (data) {
                    currPatientItem = Object.assign({}, item, {registrationInfo: data['pt_registration_info']});
                },
                error: function (err) {
                    currPatientItem = null;
                    el8.uiwidget.alert("There was an error selecting that patient. Please try again.");
                }
            });
            return false;
        }
    });
    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'winningPatient',
                selector: ':input[name="winningPatient"]',
                type: 'input',
                infoText: 'select patient chart...',
                newMindreader: true,
                mindreaderOpts: mindreaderOpts
            }
        ]
    });
    form.addButton(
        'merge-chart', 'Merge Chart', function(_form) {
            if (currPatientItem) {
                if (el8.util.string.escapedStrEqual(currPatientItem.name, _form.getVal('winningPatient'))) {
                    // Build our two patient data blocks which we'll pass to our ptMerge content function
                    var data = {
                        losingChart: {
                            name: el8.ptdata.currPatient.getLastName() + ', ' + el8.ptdata.currPatient.getFirstName(),
                            dob: el8.ptdata.currPatient.getDob().asString(),
                            sex: el8.ptdata.currPatient.getSex(),
                            passportUser: el8.ptdata.ptRegistrationInfo.getInviteStatus() === 'USED',
                            passportEmail: el8.ptdata.ptRegistrationInfo.getInviteEmail()
                        },
                        winningChart: currPatientItem
                    };
                    var dialogHeight;
                    if (el8.ptdata.ptRegistrationInfo.getInviteStatus() === 'USED' && currPatientItem.registrationInfo.is_patient_user) {
                        dialogHeight = 525;
                    } else if (el8.ptdata.ptRegistrationInfo.getInviteStatus() === 'USED' || currPatientItem.registrationInfo.is_patient_user) {
                        dialogHeight = 480;
                    } else {
                        dialogHeight = 525;
                    }
                    el8.uiwidget.confirm(
                        '',
                        function() {
                            if (el8Globals.FEATURES.NewDemographics) {
                                el8.util.amplitude.logEvent('Demographics - merge chart');
                            }
                            $.el8_ajax({
                                type: 'POST',
                                url: el8.service.urls.get('mergeChart', [currPatientItem.id]),
                                success: function(data) {
                                    _form.disable();
                                    _form.getContainer().addClass('dataLoading').empty();
                                    mergeJobId = data['job_id'];
                                    startPolling();
                                }
                            });
                        },
                        function() { that.hide(); },
                        {
                            msgTemplateFn: function() { return el8.template.appchart.dialog.mergeChart.ptMerge(data); },
                            yesBtnText: 'Yes, merge charts',
                            noBtnText: 'No',
                            prefHeight: dialogHeight
                        }
                    );
                    return;
                }
            }
            el8.uiwidget.alert('Unrecognized patient to merge into');
        }, true
    );
    form.addButton(
        'cancel-merge', 'Cancel', function() {
            that.hide();
        }, false
    );
    that.setForm(form);

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        currPatientItem = null;
        pollInterval = null;
        pollAttempts = 0;
        mergeJobId = null;
    };

    var POLL_INTERVAL = 1000;  // every 1 second
    var POLL_MAX_ATTEMPTS = 60;  // for 60 seconds

    var pollFn = function() {
        pollAttempts++;
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('mergeStatus', [mergeJobId]),
            success: function(data) {
                if (pollAttempts === POLL_MAX_ATTEMPTS) {
                    endPolling();
                    el8.uiwidget.alert('We had trouble merging the charts. Please reload this chart and try again.');
                } else if (data['complete']) {
                    endPolling();
                    el8.appservice.notifier.notify('This current chart is being merged into ' + currPatientItem.name + ', which will be loaded when the merge is complete.');
                    el8.service.pageunload.clearLoginRequired(); // don't do last-minute saves on a now-deleted patient
                    window.location.href = el8.service.urls.get('goToPatient', [currPatientItem.id]);
                }
            },
            error: function() {
                endPolling();
            }
        });
    };

    var startPolling = function() {
        pollAttempts = 0;
        pollInterval = $.el8_setInterval(function() { pollFn(); }, POLL_INTERVAL);
    };

    var endPolling = function() {
        if (pollInterval) { $.el8_clearInterval(pollInterval); }
    };

    return that;

})();
